import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import { Box, Grid } from "@mui/material";

const UserActivity = () => {
  const sidebarItems = [
    "Answers",
    "Questions",
    "Tags",
    "Responses",
    "Votes",
    "Profile",
  ];
  const [selectedItem, setSelectedItem] = useState(sidebarItems[0]); // Default to the first item

  return (
    <Grid container>
      <Grid item xs={12} md={2}>
        <Box>
          {sidebarItems.map((item, index) => (
            <Box
              key={index}
              onClick={() => setSelectedItem(item)} // Set selected item on click
              style={{
                cursor: "pointer", // Make the item clickable
                marginBottom: "4px",
                width:"60%",
                backgroundColor: selectedItem === item ? "#f0f0f0" : "transparent", // Highlight selected item
                padding: "6px",
                borderRadius: "18px",
              }}
            >
              <Typography variant="p1"  gutterBottom>
                {item}
              </Typography>
            </Box>
          ))}
        </Box>
      </Grid>

      <Grid item xs={12} md={10}>
        <Typography variant="h6">
           {selectedItem}`
        </Typography>
      </Grid>
    </Grid>
  );
};

export default UserActivity;
